export function saveToClipboard(data) {
    let hiddenInput = document.createElement('input');
    hiddenInput.value = data;
    hiddenInput.setAttribute('type', 'text');
    hiddenInput.style.opacity = '0';
    document.body.appendChild(hiddenInput);
    hiddenInput.focus();
    hiddenInput.select();
    document.execCommand('copy');
    document.body.removeChild(hiddenInput);
}


// WEBPACK FOOTER //
// ./src/common/utils/clipboard.js